import homeReducer from "./reducers/homeReducer";
import authReducer from "./reducers/authReducer";
import cardReducer from "./reducers/cardReducer";
import orderReducer from "./reducers/orderReducer";
import dashboardReducer from "./reducers/dashboardReducer";
import chatReducer from "./reducers/chatReducer";
import appointmentReducer from "./reducers/appointmentReducerClient";
import appointmentReducerClient from "./reducers/appointmentReducerClient";
import medicalFileReducer from "./reducers/medicalFileReducer";
import paymentReducer from "./reducers/paymentReducer";
const rootReducers = {
  home: homeReducer,
  auth: authReducer,
  appointments: appointmentReducer,
  appointmentsClient: appointmentReducerClient,
  medicalFile: medicalFileReducer,
  card: cardReducer,
  order: orderReducer,
  dashboard: dashboardReducer,
  chat: chatReducer,
  payment: paymentReducer,
};
export default rootReducers;
